import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/seeker/components/settings/settingTabs/index.tsx");
